import { gql } from '@lcs/shared/api';

export const getPromptDetail = gql`
   query GetPromptDetail($id: UInt!) {
      prompt(id: $id) {
         promptId
         name
         typeId
         account {
            accountId
            shortName
            name
         }
         isActive
         fileId
         file {
            fileId
            fileName
            displayName
            fileToken
            promptType
         }
         isReusable
         createDate
         createUser {
            userId
            name
         }
         updateDate
         updateUser {
            userId
            name
         }
      }
   }
`;
